export default __webpack_public_path__ + "static/media/star.9b3517e2.svg";